export default __webpack_public_path__ + "static/designer-zalo-f2cbc68e2b908043f83bac60dab338c8.jpg";